/**
 * Informazioni di versione da mostrare nel footer.
 */
export interface IVersionInfoValues {
  /** Versione applicativa (build arg APP_VERSION), assente se non valorizzata */
  appVersion?: string;
  /** Versione frontend (package.json), assente se SHOW_FRONTEND_VERSION=false */
  frontendVersion?: string;
}

/**
 * Normalizza un valore proveniente dal DefinePlugin: le variabili non
 * valorizzate possono arrivare come stringa vuota, ma anche come "null",
 * "undefined" o "false" (i profili YAML stringificano i valori assenti).
 */
function normalizeEnvValue(value: string | undefined): string | undefined {
  if (
    !value ||
    value === 'null' ||
    value === 'undefined' ||
    value === 'false'
  ) {
    return undefined;
  }
  return value;
}

/**
 * Estrae le versioni da mostrare applicando le regole di visibilità:
 * - APP_VERSION vuota o assente → versione applicativa non mostrata;
 * - SHOW_FRONTEND_VERSION === 'false' → versione frontend non mostrata.
 *
 * Nota: i valori arrivano dal DefinePlugin, quindi sono sempre stringhe
 * (i confronti vanno fatti su stringa, mai su boolean).
 */
export function getVersionInfo(): IVersionInfoValues {
  const appVersion = normalizeEnvValue(process.env.APP_VERSION);

  const normalizedFrontendVersion =
    process.env.SHOW_FRONTEND_VERSION !== 'false'
      ? normalizeEnvValue(process.env.VERSION)
      : undefined;
  const frontendVersion = normalizedFrontendVersion
    ? `v${normalizedFrontendVersion}`
    : undefined;

  return { appVersion, frontendVersion };
}

/**
 * Indica se c'è almeno una versione da mostrare nel footer statico.
 * Utile ai layout per regolare il margine del footer del tema.
 */
export function hasVersionInfo(): boolean {
  const { appVersion, frontendVersion } = getVersionInfo();
  return Boolean(appVersion ?? frontendVersion);
}
